import * as React from 'react';
import { useDispatch, useSelector } from '@grandvisionhq/state';
import { Hooks } from '@grandvisionhq/stores-v2';
import { getServiceStore } from '../../../selectors.js';
import { selectServiceStore } from '../../../StepShipping/actions.js';
import { StoreSummary } from '../components/StoreSummary.js';

const StoreSummaryContainer = ({ storeCode , actions , resetServiceStore , className  })=>{
    const dispatch = useDispatch();
    const [getStoreByCode, storeByCode] = Hooks.useStoreByCode();
    const serviceStore = useSelector(getServiceStore);
    React.useEffect(()=>{
        if (storeCode && (serviceStore === null || serviceStore === void 0 ? void 0 : serviceStore.code) !== storeCode) {
            getStoreByCode({
                variables: {
                    code: storeCode
                }
            });
        }
    }, [
        storeCode,
        getStoreByCode,
        serviceStore
    ]);
    React.useEffect(()=>{
        if (storeByCode.error) {
            dispatch(selectServiceStore({
                serviceStore: null
            }));
            resetServiceStore && resetServiceStore();
            return;
        }
        if (storeByCode.data && storeByCode.data.code !== (serviceStore === null || serviceStore === void 0 ? void 0 : serviceStore.code)) {
            const { code , name , streetName , streetNumber , town  } = storeByCode.data;
            const newServiceStore = {
                code,
                name,
                streetName,
                streetNumber,
                town
            };
            dispatch(selectServiceStore({
                serviceStore: newServiceStore
            }));
        }
    }, [
        dispatch,
        resetServiceStore,
        serviceStore === null || serviceStore === void 0 ? void 0 : serviceStore.code,
        storeByCode.data,
        storeByCode.error
    ]);
    if (!serviceStore) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(StoreSummary, {
        className: className,
        name: serviceStore.name,
        streetName: serviceStore.streetName,
        streetNumber: serviceStore.streetNumber,
        actions: actions
    });
};

export { StoreSummaryContainer };
//# sourceMappingURL=StoreSummaryContainer.js.map
